import React, { useState } from 'react';
import OpsClientInvites from './OpsClientInvites';
import OpsOrganizationPanel from './OpsOrganizationPanel';
import OpsUserDetailsPage from './OpsUserDetailsPage';

export default function OpsDirectoryViews({ navigation, plans, formatDate, onRefresh, children }) {
  const [listTab, setListTab] = useState('users');
  return (
    <>
      {navigation.isList && (
        <div
          role="tablist"
          aria-label="User Management views"
          className="flex gap-3 border-b mb-5 pb-3"
        >
          {['users', 'invites'].map((tab) => (
            <button
              key={tab}
              role="tab"
              aria-selected={listTab === tab}
              onClick={() => setListTab(tab)}
              className={`px-4 py-2 rounded-lg ${listTab === tab ? 'bg-blue-100 text-blue-800' : 'text-gray-600'}`}
            >
              {tab === 'users' ? 'Users' : 'Invites'}
            </button>
          ))}
        </div>
      )}
      <div hidden={!navigation.isList || listTab !== 'users'}>{children}</div>
      {navigation.isList && listTab === 'invites' && (
        <OpsClientInvites onOpenUser={navigation.openUser} />
      )}
      {navigation.routes.map((route, index) => (
        <section
          key={route.key}
          hidden={index !== navigation.routes.length - 1}
          aria-label={route.type === 'user' ? 'User details page' : 'Organization details page'}
        >
          <div className="flex flex-wrap gap-4 mb-5">
            <button onClick={navigation.back} className="text-blue-700 hover:underline">
              ← Back
            </button>
            <button onClick={navigation.backToUsers} className="text-blue-700 hover:underline">
              Back to users
            </button>
          </div>
          {route.type === 'user' ? (
            <OpsUserDetailsPage
              id={route.id}
              tab={route.tab}
              onTabChange={(tab) => navigation.setTab(route.key, tab)}
              onOpenOrganization={navigation.openOrganization}
              plans={plans}
              formatDate={formatDate}
              onRefresh={onRefresh}
            />
          ) : (
            <OpsOrganizationPanel
              user={route.user}
              tab={route.tab}
              onTabChange={(tab) => navigation.setTab(route.key, tab)}
              onOpenUser={navigation.openUser}
              plans={plans}
              onRefresh={onRefresh}
            />
          )}
        </section>
      ))}
    </>
  );
}
